
import Moderator from '@/models/bread/Moderator/eventSchoolYear'


export default {
    key: 'EventSchoolYear',
    name: {
        singular: 'SchoolYear',
        plural: 'SchoolYears',
    },
    parents: [
        'Event',
    ],
    Admin: false,
    Moderator: Moderator,
    Teacher: false,
}